import { NewSchoolInputType } from '../../type/New/NewSchoolInput.type';
import { newSchoolInputDataInitial } from './newSchoolInputDataInitial';
import { newSchoolInputValidateInitial } from './newSchoolInputValidateInitial';

export const newSchoolInputInitial: NewSchoolInputType = {
    input: newSchoolInputDataInitial,
    validate: newSchoolInputValidateInitial,
};